export class NotFound extends Error {}
